<template>
  <DocumentTitleProvider title="Content Lab">
    <div
      id="content-lab"
      data-testid="content-lab"
      class="grow"
      :style="{
        height: `calc(100vh - 74px)`
      }"
    />
    <SetNewPasswordDialog v-if="showSetNewPasswordDialog" />
    <VideoLibraryTableDialog
      v-if="isVideoLibraryDialogOpen"
      :selectable="false"
      context="content-lab"
      @close="closeVideoLibraryDialog"
    />
  </DocumentTitleProvider>
</template>

<script>
import logger from '@goldcast/logger';
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'vuex';

import SetNewPasswordDialog from './auth/SetNewPasswordDialog.vue';
import renderReactComponent from './renderReactComponent';
import VideoLibraryTableDialog from '../videoLibrary/VideoLibraryTableDialog.vue';

import DocumentTitleProvider from '@/studioComponents/DocumentTitleProvider.vue';

let unmount = null;

export default defineComponent({
  name: 'ContentLab',
  components: {
    DocumentTitleProvider,
    SetNewPasswordDialog,
    VideoLibraryTableDialog
  },
  mounted() {
    this.checkForceChangePassword();
    import('content_studio/renderApp')
      .then(({ default: renderApp }) => {
        unmount = renderReactComponent(renderApp, 'content-lab');
      })
      .catch(err => {
        logger.error('[ContentLab] Failed importing content_studio/renderApp', err);
      });
  },
  unmounted() {
    if (unmount) {
      unmount();
    }
  },
  computed: {
    ...mapState('user', { showSetNewPasswordDialog: 'showSetNewPasswordDialog' }),
    ...mapState('contentStudio', { isVideoLibraryDialogOpen: 'isVideoLibraryDialogOpen' })
  },
  methods: {
    ...mapActions('user', {
      checkForceChangePassword: 'checkForceChangePassword'
    }),
    ...mapActions('contentStudio', {
      toggleVideoLibraryDialog: 'toggleVideoLibraryDialog'
    }),
    closeVideoLibraryDialog() {
      this.toggleVideoLibraryDialog(false);
    }
  }
});
</script>
